module.exports = __webpack_public_path__ + "media/tally2.86797c9d.webm";